if (!customElements.get('userway-widget')) {
  customElements.define(
    'userway-widget',
    class extends HTMLElement {
      connectedCallback() {
        const script = document.createElement('script');
        for (const { name, value } of this.attributes) {
          script.setAttribute(name, value);
        }
        (document.body || document.head).appendChild(script);
      }
    }
  );
}

if (!customElements.get('userway-mobile-trigger')) {
  customElements.define(
    'userway-mobile-trigger',
    class extends HTMLElement {
      constructor() {
        super();

        this.mobileTrigger = this.querySelector('button');
        this.triggerSelector = this.dataset.trigger?.substring(1);
      }
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 990px)');
        this.mq.addEventListener('change', this.toggleTarget.bind(this));
        this.toggleTarget(this.mq);
      }

      disconnectedCallback() {
        this.mq.removeEventListener('change', this.toggleTarget.bind(this));
      }

      toggleTarget({ matches: isMobile }) {
        this.mobileTrigger?.classList.toggle(this.triggerSelector, isMobile);
        const defaultTrigger = document.getElementById('userwayAccessibilityIcon');
        defaultTrigger?.classList.toggle('hidden', isMobile);
      }
    }
  );
}
